<template>
  <footer id="vueFooter" class="footer" v-bind:class="{'force-footer': isModePoint, 'd-none': isLogin}">
    <div v-if="!isModePoint" class="row">
        <div class="col-xs-12 col-sm-12 col-md-12">

          <div class="logo">
            <img v-if="isDarkFooter" src="/src/assets/img/logo-theme-dark.png" class="img-responsive" alt="logo">
            <img v-else src="../../../assets/logoFooter.png" class="img-responsive" alt="logo-footer"/>
          </div>

          <ul class="social-icons">
            <li><a href="https://www.linkedin.com/company/marqpontoapp/" target="_blank"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a></li>
            <li><a href="https://www.facebook.com/marqponto/" target="_blank"><i class="fa fa-facebook-square" aria-hidden="true"></i></a></li>
            <li><a href="https://www.instagram.com/marqponto/" target="_blank"><i class="fab fa fa-instagram"></i></a></li>
            <li><a href="https://play.google.com/store/apps/details?id=br.com.marqponto" target="_blank"><i class="fab fa fa-play"></i></a></li>
            <li><a href="https://itunes.apple.com/br/app/marqponto/id1379890385?l=pt&ls=1&mt=8" target="_blank"><i class="fab fa fa-apple"></i></a></li>
          </ul>

          <span class="copyright nunito">MarQPonto © 2022. Todos os direitos reservados.</span>
        </div>
      </div>
    <div v-if="isModePoint" class="row new-row">
      <div class="col-xs-12 col-sm-12 col-md-12 new-footer">
        <div class="footer-art">
          <img src="../../../assets/img/logo-white.png" alt="Logo MarQ">
          <a href="https://www.facebook.com/marqponto/" target="_blank"><ion-icon name="logo-facebook"></ion-icon></a>
          <a href="https://www.instagram.com/marqponto/" target="_blank"><ion-icon name="logo-instagram"></ion-icon></a>
          <a href="https://www.linkedin.com/company/marqpontoapp/" target="_blank"><ion-icon name="logo-linkedin"></ion-icon></a>
          <a href="https://www.youtube.com/channel/UCOseAaAQ9NNR1wE5jq2TZSg/" target="_blank"><ion-icon name="logo-youtube"></ion-icon></a>
          <a href="https://play.google.com/store/apps/details?id=br.com.marqponto" target="_blank"><ion-icon name="logo-google-playstore"></ion-icon></a>
          <a href="https://itunes.apple.com/br/app/marqponto/id1379890385?l=pt&ls=1&mt=8" target="_blank"><ion-icon name="logo-apple"></ion-icon></a>
        </div>
        <span class="copyright nunito">MarQPonto © 2022. Todos os direitos reservados.</span>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name:'vue-footer',
    data() {
      return {
        isModePoint: false,
        isLogin: false,
        isDarkFooter: false
      }
    },
    methods: {
      footerAlign() {
        $('footer').css('display', 'block');
        $('footer').css('height', 'auto');
        let footerHeight = $('footer').outerHeight();
        $('body').css('padding-bottom', footerHeight);
        $('footer').css('height', footerHeight);
      }
    },
    updated(){
    },
    mounted(){
      // this.footerAlign();
      //
      // $(window).resize(function() {
      //   $('footer').css('display', 'block');
      //   $('footer').css('height', 'auto');
      //   let footerHeight = $('footer').outerHeight();
      //   $('body').css('padding-bottom', footerHeight);
      //   $('footer').css('height', footerHeight);
      // });
      switch (window.location.pathname) {
        case '/registro-de-pontos':
          this.isModePoint = true;
          this.isLogin = false;
          break;
        case '/login':
          this.isModePoint = false;
          this.isLogin = true;
          break;
        default:
          this.isModePoint = false;
          this.isLogin = false;
          break;
      }
    },
    beforeMount() {
      switch (window.location.pathname) {
        case '/registro-de-pontos':
          this.isModePoint = true;
          this.isLogin = false;
          break;
        case '/login':
          this.isModePoint = false;
          this.isLogin = true;
          break;
        default:
          this.isModePoint = false;
          this.isLogin = false;
          break;
      }
    }
  }
</script>

<style lang="scss">

.force-footer {
  height: 70px;
  background: linear-gradient(254.93deg, #1A0F6B 2.82%, #1C116F 28.98%, #21177A 54.17%, #2A218D 78.39%, #352DA5 99.71%);
}

.new-row {
  height: 100%;

  .new-footer {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .footer-art {
      display: flex;
      align-items: flex-end;

      img {
        margin-right: 10px;
      }

      a {
        text-decoration: none;
        cursor: pointer;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
          margin-bottom: 1px;
        }

        ion-icon {
          color: #ffffff;
          font-size: 18px;
        }
      }
    }

    .copyright {
      margin-top: 5px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/components/footer.vue